import React, { useState, useEffect } from 'react';
import { ShieldCheck, Cookie, ArrowRight, Lock } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from './ui/button';

// 🔥 DİL ENTEGRASYONU 🔥
import { useLanguage } from '../context/LanguageContext';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useLanguage(); // Dil fonksiyonunu al

  useEffect(() => {
    // Kullanıcı siteye girdikten 1.5 saniye sonra nazikçe belirsin
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'true');
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div 
          initial={{ opacity: 0, y: 100, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 50, scale: 0.9 }}
          transition={{ type: "spring", stiffness: 300, damping: 30 }}
          className="fixed bottom-24 md:bottom-8 left-4 right-4 md:left-8 md:right-auto md:max-w-md z-[90] font-sans"
        >
          <div className="bg-[#0f172a]/90 backdrop-blur-2xl border border-white/10 p-6 rounded-[2.5rem] shadow-[0_20px_60px_-15px_rgba(0,0,0,0.5)] flex flex-col gap-6 relative overflow-hidden ring-1 ring-white/5">
            
            {/* Decorative Background Elements */}
            <div className="absolute top-0 right-0 w-32 h-32 bg-orange-500/10 rounded-full blur-[50px] pointer-events-none" />
            
            <div className="flex items-start gap-5 relative z-10">
              <div className="relative">
                  <div className="w-14 h-14 bg-orange-500/10 rounded-2xl flex items-center justify-center border border-orange-500/20 text-orange-500 shadow-[0_0_20px_rgba(249,115,22,0.2)]">
                    <ShieldCheck size={28} strokeWidth={2.5} />
                  </div>
                  <div className="absolute -bottom-1 -right-1 bg-[#0f172a] rounded-full p-1 border border-white/10">
                      <Lock size={12} className="text-emerald-500" />
                  </div>
              </div>
              
              <div className="space-y-1">
                <h4 className="text-sm font-black text-white uppercase tracking-wider flex items-center gap-2">
                  {t('cookie_title') || 'Secure Connection'} <div className="w-1.5 h-1.5 bg-emerald-500 rounded-full animate-pulse" />
                </h4>
                <p className="text-[11px] text-slate-400 leading-relaxed font-medium">
                  {t('cookie_desc') || 'Data privacy is our priority. We use AES-256 encryption and secure cookies on our Frankfurt servers.'}
                </p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 pt-2 relative z-10">
              <Button 
                onClick={handleAccept} 
                className="flex-1 h-12 bg-orange-600 hover:bg-orange-500 text-white font-black uppercase tracking-widest text-[10px] rounded-xl shadow-lg shadow-orange-900/40 active:scale-95 transition-all group"
              >
                {t('cookie_accept') || 'Accept Protocol'} <ArrowRight size={14} className="ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>
              <Button 
                variant="ghost" 
                onClick={() => setIsVisible(false)} 
                className="flex-1 h-12 bg-white/5 hover:bg-white/10 text-slate-400 hover:text-white font-bold text-[10px] uppercase tracking-widest rounded-xl transition-colors border border-white/5"
              >
                {t('cookie_essential') || 'Essential Only'}
              </Button>
            </div>

            {/* Bottom Badge */}
            <div className="flex items-center justify-center gap-2 pt-4 border-t border-white/5 mt-2 opacity-60">
                <Cookie size={12} className="text-slate-500" />
                <span className="text-[9px] font-mono text-slate-500 uppercase tracking-widest">{t('cookie_badge') || 'GDPR Compliant'}</span>
            </div>

          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;